/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Pick_Preset_TitleInputs */

const en_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose export preset`)
};

const fr_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez le préréglage d'exportation`)
};

const de_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportvoreinstellung auswählen`)
};

const it_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il preset di esportazione`)
};

const ru_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предустановку экспорта`)
};

const es_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el ajuste preestablecido de exportación`)
};

const zh_cn2_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择导出预设`)
};

const ja_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートプリセットを選択`)
};

const hi_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात प्रीसेट चुनें`)
};

const pt_pt2_explorer_info_batch_pick_preset_title = /** @type {(inputs: Explorer_Info_Batch_Pick_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a predefinição de exportação`)
};

/**
* | output |
* | --- |
* | "Choose export preset" |
*
* @param {Explorer_Info_Batch_Pick_Preset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_pick_preset_title = /** @type {((inputs?: Explorer_Info_Batch_Pick_Preset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Pick_Preset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_pick_preset_title(inputs)
	if (locale === "de") return de_explorer_info_batch_pick_preset_title(inputs)
	if (locale === "it") return it_explorer_info_batch_pick_preset_title(inputs)
	if (locale === "ru") return ru_explorer_info_batch_pick_preset_title(inputs)
	if (locale === "es") return es_explorer_info_batch_pick_preset_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_pick_preset_title(inputs)
	if (locale === "ja") return ja_explorer_info_batch_pick_preset_title(inputs)
	if (locale === "hi") return hi_explorer_info_batch_pick_preset_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_pick_preset_title(inputs)
	return en_explorer_info_batch_pick_preset_title(inputs)
});